<template>
    <div v-if="show"
         class="form-group"
         :class="{'has-error': hasError}">
        <!-- <label class="control-label has-error">{{ l('PAYMENT.TRANSACTION_REF__LABEL') }}</label> -->
        <input ref="input"
               class="form-control input-lg"
               :placeholder="placeholder"
               :value="modelValue"
               maxlength="30"
               :required="required"
               @change="onChange"
               @input="onInput"
               @keydown.enter="$emit('enter')" />
    </div>
</template>

<script>
import ManuallyInputtedTransactionRefStatus from '@/lib/Payments/ManuallyInputtedTransactionRefStatus';
import { container } from '@/container';

export default {
    props: {
        modelValue: {
            type: String,
            default: '',
        },

        paymentMethod: {
            type: Object,
            required: true,
        },
    },

    emits: ['update:modelValue', 'enter'],

    data() {
        return {
            hasError: false,
        };
    },

    computed: {
        /**
         * @return {('optional'|'required'|'unsupported')}
         */
        transactionRefStatus() {
            return this.paymentMethod.manuallyInputtedTransactionRefStatus;
        },

        show() {
            return this.transactionRefStatus === ManuallyInputtedTransactionRefStatus.REQUIRED
                || this.transactionRefStatus === ManuallyInputtedTransactionRefStatus.OPTIONAL;
        },

        required() {
            return this.transactionRefStatus === ManuallyInputtedTransactionRefStatus.REQUIRED;
        },

        placeholder() {
            return container.langService.getText(
                this.required ? 'PAYMENT.TRANSACTION_REF_REQUIRED' : 'PAYMENT.TRANSACTION_REF_OPTIONAL'
            );
        },
    },

    methods: {
        focus() {
            this.$refs.input?.focus();
        },

        onInput(event) {
            this.$emit('update:modelValue', event.currentTarget.value);
        },

        onChange() {
            this.validate();
        },

        validate() {
            this.hasError = false;
            if (this.required && !this.modelValue) {
                this.hasError = true;
                return false;
            }

            return true;
        },
    },
};
</script>
